import { render, staticRenderFns } from "./PxCodInternoCodProxpectCompra.vue?vue&type=template&id=fd87a6e0&"
import script from "./PxCodInternoCodProxpectCompra.vue?vue&type=script&lang=js&"
export * from "./PxCodInternoCodProxpectCompra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports